import {
  isNotEmpty_default
} from "./chunk-UUVQ4RET.mjs";
import {
  isNotNaN_default
} from "./chunk-ZDTRL3MX.mjs";

// src/ramda-adjunct/isTruthy.ts
import isNil from "ramda/src/isNil";
function isTruthy(val) {
  if (isNil(val)) {
    return false;
  } else if (typeof val === "number") {
    return val !== 0 && isNotNaN_default(val);
  } else if (typeof val === "boolean") {
    return val;
  } else if (typeof val === "object" || Array.isArray(val)) {
    return true;
  }
  return isNotEmpty_default(val);
}
var isTruthy_default = isTruthy;

export {
  isTruthy_default
};
//# sourceMappingURL=chunk-A2YU2TMP.mjs.map